import { ValidationTypeEnum } from '../../model/enumerations/validation-type.enum';
import { DropdownDictionary } from '../../model/dropdownDictionary';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { OnSaveData } from '../../interfaces/on-save-data';
import { InputValidationService } from '../../../core/services/input-validation.service';

@Component({
    selector: 'app-drop-down-input',
    templateUrl: './drop-down-input.component.html',
    styleUrls: ['./drop-down-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropDownInputComponent implements OnInit, OnSaveData {
  @Input() name: string;
  @Input() items: DropdownDictionary[];
  @Input() value: string;
  @Input() selectedItemId: any;
  @Input() validate: boolean;
  @Input() validationType: ValidationTypeEnum;
  @Input() validationTypeToInput: string;
  @Input() searchable = false;
  @Input() disabled: boolean;
  @Input() blockEmail: boolean;
  @Input() placeholder: string;
  @Input() testId: string;
  @Output() valueChange = new EventEmitter();
  @Output() selectedItemIdChange = new EventEmitter();
  @Output() saveModel = new EventEmitter();
  @Output() showNationalId = new EventEmitter();

  oldSelectedItemId: string;
  oldValue: string;
  searchValue: string = "";
  lastEventValue : string | null = null;

  constructor(private inputValidationService: InputValidationService) {}

  ngOnInit(): void {}

  onSelectedItemIdChange(): void {
    this.selectedItemIdChange.emit(this.selectedItemId);
  }

  onMouseClick(event : any): void {
	if (this.searchValue != this.lastEventValue) {
		this.valueChange.emit(this.searchValue);
		this.lastEventValue = this.searchValue;
   	}
  }
  onValueChange(event : any): void {
	this.searchValue = event.target.value;
	if ("Enter" === event.key || "Tab" === event.key || "Space" === event.key) {
    	this.lastEventValue = null;
  	} else if (this.searchValue != this.lastEventValue) {
		this.valueChange.emit(this.searchValue);
		this.lastEventValue = this.searchValue;
   	}
  }

  onSaveModelDropDown(): void {
    if (this.oldSelectedItemId !== this.selectedItemId) {
      this.onSaveModel();
    }
  }

  onSaveModelInput(): void {
    if (this.oldValue !== this.value) {
      this.onSaveModel();
    }
  }

  onSaveModel(): void {
    this.saveModel.emit();
  }

  onSaveState(): void {
  }

  onSaveStateDropDown(): void {
    this.oldSelectedItemId = this.selectedItemId;
  }
  onSaveStateInput(): void {
    this.oldValue = this.value;
  }

  showNationalIdClick(): void {
    this.showNationalId.emit();
  }

  isValidated(val: any): boolean {
    return this.inputValidationService.isValidated(val, this.validationType);
  }
}
